import React from 'react';
import { Link } from 'react-router-dom';
import { Truck, Mail, MapPin, Phone } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300 mt-auto" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_verifiedlogistics/artifacts/n9slup3y_logo.JPG" 
                alt="StraightConnect Logo" 
                className="h-8 w-auto"
              />
              <span className="font-heading text-xl font-bold text-white tracking-tight">
                StraightConnect
              </span>
            </div>
            <p className="text-sm text-slate-400">
              Empowering non-CDL carriers with AI-driven intelligence, verification, and opportunities.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-white font-semibold mb-4">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/resources" className="hover:text-blue-400 transition-colors" data-testid="footer-resources-link">
                  Resources
                </Link>
              </li>
              <li>
                <Link to="/join" className="hover:text-blue-400 transition-colors" data-testid="footer-join-link">
                  Join Network
                </Link>
              </li>
              <li>
                <Link to="/about" className="hover:text-blue-400 transition-colors" data-testid="footer-about-link">
                  About Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h4 className="font-heading text-white font-semibold mb-4">Support</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/help-center" className="hover:text-blue-400 transition-colors" data-testid="footer-help-link">
                  Help Center
                </Link>
              </li>
              <li>
                <a href="#" className="hover:text-blue-400 transition-colors">
                  Contact Us
                </a>
              </li>
              <li>
                <Link to="/privacy-policy" className="hover:text-blue-400 transition-colors" data-testid="footer-privacy-link">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-white font-semibold mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-2">
                <Mail className="h-4 w-4 text-blue-400" />
                <span>support@straightconnect.org</span>
              </li>
              <li className="flex items-center gap-2">
                <Phone className="h-4 w-4 text-blue-400" />
                <span>281-817-0176</span>
              </li>
              <li className="flex items-center gap-2">
                <MapPin className="h-4 w-4 text-blue-400" />
                <span>Houston, TX</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 text-center text-sm text-slate-500">
          <p>&copy; 2026 StraightConnect. All rights reserved. Built with Emergent.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;